import { DownOutlined, UpOutlined } from '@ant-design/icons'

function ProductSourceBodyWrapper({
  title,
  children,
  headerInline,
  collapsible = false,
  isCollapsed = false,
  onToggleCollapsed,
}: {
  title: string
  children: React.ReactNode
  /** Rendered next to the title — the feed URL and sync warning when collapsed. */
  headerInline?: React.ReactNode
  /** When true, the header carries a chevron and the body can be hidden. */
  collapsible?: boolean
  isCollapsed?: boolean
  onToggleCollapsed?: () => void
}): JSX.Element {
  return (
    <div className="flex flex-col p-6 bg-gray-50 rounded-lg">
      <div
        className={`flex flex-row justify-between items-center gap-4 ${
          isCollapsed ? '' : 'pb-12'
        } ${collapsible ? 'cursor-pointer' : ''}`}
        onClick={collapsible ? onToggleCollapsed : undefined}
      >
        <div className="flex items-center gap-2 min-w-0">
          <h2 className="text-xl font-medium text-gray-900 whitespace-nowrap m-0">
            {title}
          </h2>
          {headerInline}
        </div>
        {collapsible && (
          <button
            type="button"
            aria-label={isCollapsed ? 'Expand' : 'Collapse'}
            className="shrink-0 border-0 bg-transparent cursor-pointer text-gray-500 hover:text-gray-700 p-1"
            onClick={(e) => {
              // The whole header toggles too; stop the row handler from firing
              // a second time and cancelling this one out.
              e.stopPropagation()
              onToggleCollapsed?.()
            }}
          >
            {isCollapsed ? <DownOutlined /> : <UpOutlined />}
          </button>
        )}
      </div>
      {!isCollapsed && children}
    </div>
  )
}

export default ProductSourceBodyWrapper
